<template>
    <li :class="`plan-basket-item${this.primary ? ' --primary' : ''}`">
        <div v-if="iconBullet"
             class="plan-basket-item__cell --bullet">
            <i class="plan-basket-item__bullet fas fa-check" />
        </div>
        <div v-else-if="imageBullet"
             class="plan-basket-item__cell --bullet">
            <div v-if="item.hasImage"
                 :class="`plan-basket-item__image${this.primary ? ' --primary' : ''}`"
                 :style="`background-image: url('${item.imageUrl}');`" />
            <div v-else
                 :class="`plan-basket-item__image --default${this.primary ? ' --primary' : ''}`" />
        </div>
        <div class="plan-basket-item__cell">
            <span v-if="segment"
                  class="plan-basket-item__segment">{{ segment }}</span>
            <span class="plan-basket-item__text">{{ this.item.title }}</span>
            <span :class="`plan-basket-item__more-link-wrapper${this.primary ? ' --primary' : ''}`">
                (<a :class="`plan-basket-item__more-link${this.primary ? ' --primary' : ''}`"
                    tabindex="0"
                    @keyup.enter="onViewInfo"
                    @click="onViewInfo">more&hellip;</a>)
            </span>
        </div>
        <div class="plan-basket-item__cell --last">
            <div :class="`plan-basket-item__cost${this.primary ? ' --primary' : ''}`">
                <span v-if="!$scheme.priceless">{{ this.item.priceDisplay }}</span>
            </div>
            <a v-if="editable"
               class="plan-basket-item__remove-link"
               tabindex="0"
               @keyup.enter="$emit('remove', item.id)"
               @click="$emit('remove', item.id)">remove</a>
        </div>
    </li>
</template>

<script>

import _ from 'lodash'

import Casing from '../../helpers/casing'

import Improvement from '@/models/improvement'

import ImprovementInfo from './modals/improvement-info'

export default {

    props: {
        item: {
            type: Improvement,
            required: true,
        },
        displayType: {
            type: String,
            default: 'standard',
        },
        editable: {
            type: Boolean,
            default: false,
        },
        primary: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        iconBullet() {
            return this.displayType === 'icon'
        },

        imageBullet() {
            return this.displayType === 'image'
        },

        segment() {
            if (!this.primary) return ''
            const mapping = this.$scheme.segmentKeymap.find(mp => mp.key === this.item.segmentKey)
            return mapping ? mapping.text : ''
        },
    },

    methods: {

        onViewInfo() {
            const key = Casing.kebabCase(this.item.title)
            history.pushState({ key }, this.item.title, `#${ key }`)
            this.$eventbus.$emit(this.$appevents.showModal, ImprovementInfo, {
                data: { item: _.cloneDeep(this.item) },
                cssModifier: 'info',
                onClose: () => history.back(),
            })
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\app-core\_plan-basket-item.scss

.plan-basket-item {
    display: table;
    width: 100%;
    font-size: 0.8rem;
    line-height: 0.9rem;
    padding: 0.5rem 0 !important;

    &.--primary {
        font-size: 0.9rem;
    }

    @include element('cell') {
        display: table-cell;
        padding: 0 0.2rem;
        vertical-align: top;

        &.--bullet {
            width: rem(28px);
        }

        &.--last{
            vertical-align: bottom;
            text-align: right;
        }
    }

    @include element('bullet') {
        padding: 0.25rem;
    }

    @include element('image') {
        height: rem(40px);
        width: rem(40px);
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;

        &.--primary {
            height: rem(46px);
            width: rem(72px);

            @include bp-min-small {
                height: rem(50px);
                width: rem(100px);
            }
        }
    }

    @include element('segment') {
        display: none;
        line-height: 1rem;
        margin-bottom: 0.2rem;
        font-weight: bold;

        @include bp-min-small {
            display: block;
        }
    }

    @include element('more-link-wrapper') {
        margin-left: 0.2rem;

        &.--primary {
            display: block;
            margin: 0;
        }
    }

    @include element('cost') {

        &.--primary {
            font-size: 1rem;
        }
    }

    a {
        cursor: pointer;
        font-weight: bold;
    }

}

</style>
